<template>
  <div class="grid-container margin-top-2">
    <div class="grid-x">
      <div class="cell">
        <h2>Birkenbeul SSL Reminder and Server Up Checker</h2>
      </div>
    </div>
    <div class="grid-x margin-top-2">
      <div class="cell medium-6">
        <div class="margin-bottom-1">
          <div class="" v-if="!ui.showNewSite">
            <a class="button" href="#" @click="showAddSite()">Add Site</a>
          </div>
          <div class="" v-else>
            <div class="input-group">
              <span class="input-group-label">https://</span>
              <input class="input-group-field" ref="siteurl" @keyup.enter="addSite()" type="text" v-model="newSite.url">
            </div>
            <div class="button-group">
              <a class="button" href="#" @click="addSite()">Add</a>
              <a class="button secondary" href="#" @click="ui.showNewSite = false">Cancel</a>
            </div>
          </div>
        </div>
      </div>
      <div class="cell medium-6" v-if="!ui.showNewSite">
        <input placeholder="Search" type="text" v-model="state.filterString">
      </div>
    </div>
    <div class="site-list-wrapper margin-bottom-2">
      <template v-for="site of $store.compFilteredSiteList" >
        <site-list-item :site="site" :key="site.id" />
      </template>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
//import HelloWorld from '@/components/HelloWorld.vue'
import siteListItem from '@/components/siteListItem.vue'

export default {
  name: 'Home',
  data: function() {
    return {
      state: this.$store.state,
      newSite: {
        url: ''
      },
      ui: {
        showNewSite: false
      }
    }
  },
  components: {
    siteListItem
  },
  mounted() {
    this.$store.getSites()

  },
  computed: {
  },
  methods: {
    showAddSite() {
      this.ui.showNewSite = true
      console.log(this.$refs)
      this.$nextTick(() => this.$refs.siteurl.focus() )
    },
    async addSite() {
      try {
        this.$store.addSite(this.newSite)
      } catch(err) {
        console.log(err)
      }
      this.newSite = {
        url: ''
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.site-list-wrapper {
  box-shadow:0 0 15px 4px rgba(0,0,0,0.3)
  border-radius:6px
}
.site-list {
  padding:10px
}
.site-list:nth-child(even) {
  background-color: rgba(0,0,0,0.1);
}
</style>

